import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OfficeShellPanelState, OfficeShellPanelType } from 'common/components/Layout/OfficeShellPanel/OfficeShellPanel.types';
import {
  getScreenHeight,
  getScreenMode,
  getScreenSize,
  ScreenHeight,
  ScreenMode,
  ScreenSize,
} from 'common/utilities/ResponsiveBreakpoints';

import { getDefaultLayoutState, ILayoutState, INotification } from './layoutState';

const initialState: ILayoutState = getDefaultLayoutState();

interface IScreenPayload {
  height: ScreenHeight;
  size: ScreenSize;
  mode: ScreenMode;
}

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    hideNavigation: (state, action: PayloadAction<boolean>) => {
      state.isNavigationVisible = !action.payload;
    },
    showOfficeShellPanel: (state, action: PayloadAction<OfficeShellPanelState>) => {
      state.officeShellPanel = action.payload;
    },
    hideOfficeShellPanel: (state) => {
      state.officeShellPanel = undefined;
    },
    showNotification: (state, action: PayloadAction<INotification>) => {
      if (!state.notifications.find((n) => n.id === action.payload.id)) {
        state.notifications.push(action.payload);
      }
    },
    hideNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter((n) => n.id.toLowerCase() !== action.payload.toLowerCase());
    },
    blurBackground: (state, action: PayloadAction<boolean>) => {
      state.isBlurryBackground = action.payload;
    },
    setCustomScrollBar: (state, action: PayloadAction<boolean>) => {
      state.useCustomScrollBar = action.payload;
    },
    screenSizeChanged: {
      reducer: (state, action: PayloadAction<IScreenPayload>) => {
        if (state.screenHeight !== action.payload.height) {
          state.screenHeight = action.payload.height;
        }
        if (state.screenSize !== action.payload.size) {
          state.screenSize = action.payload.size;
        }
        if (state.screenMode !== action.payload.mode) {
          state.screenMode = action.payload.mode;
        }
      },
      prepare: () => {
        const newScreenHeight = getScreenHeight();
        const newScreenSize = getScreenSize();
        const newScreenMode = getScreenMode();
        return {
          payload: { height: newScreenHeight, size: newScreenSize, mode: newScreenMode },
        };
      },
    },
  },
});

export const {
  hideNavigation,
  showOfficeShellPanel,
  hideOfficeShellPanel,
  screenSizeChanged,
  showNotification,
  hideNotification,
  blurBackground,
  setCustomScrollBar,
} = layoutSlice.actions;

export default layoutSlice.reducer;
